// An email address is never a person's name.
//
// Contacts arrive from portal signups, lead feeds and CSV imports with their
// email address sitting in the `name` column, so anything that copies
// `contact.name` into a field that gets PRINTED (e.g. the vendor's name on an
// e-sign authority) can end up printing an email address where the name goes
// (Simon Abbott, Monday 12985884246). Mirrors core/utils/person_names.py on the
// backend.

const EMAILISH = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const PLACEHOLDERS = new Set(['anonymous', 'unknown', 'n/a', 'na', '-', '--']);

export const looksLikeEmail = (value) => EMAILISH.test(String(value || '').trim());

// The value if it can be printed as somebody's name, else ''.
export const cleanPersonName = (value) => {
  const v = String(value || '').trim();
  if (!v || PLACEHOLDERS.has(v.toLowerCase()) || looksLikeEmail(v)) return '';
  return v;
};

// Best printable name for a contact/owner record, or '' when we don't know it.
export const personDisplayName = (p) => {
  if (!p) return '';
  const first = String(p.first_name || '').trim();
  const last = String(p.last_name || '').trim();
  return (
    cleanPersonName(p.preferred_name)
    || cleanPersonName(p.name)
    || cleanPersonName(`${first} ${last}`.trim())
  );
};

export default personDisplayName;
